import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUserStore = defineStore('user', () => {
  const usuario = ref(null)
  const negocios = ref([])
  const negocioSeleccionado = ref(null)

  // Role-based computed properties
  const isSuper = computed(() => {
    // Check if user has rol_id = 1 (Super Admin)
    return usuario.value?.rol_id === 1
  })

  const canManageUsers = computed(() => isSuper.value)
  const canManageBusinesses = computed(() => isSuper.value)

  function setUserData({ usuario: u, negocios: n }) {
    usuario.value = u
    negocios.value = n.map(({ pivot, ...rest }) => rest)
    negocioSeleccionado.value = null
  }

  function seleccionarNegocio(negocio) {
    negocioSeleccionado.value = negocio
  }

  function logout() {
    usuario.value = null
    negocios.value = []
    negocioSeleccionado.value = null
  }

  return {
    usuario,
    negocios,
    negocioSeleccionado,
    isSuper,
    canManageUsers,
    canManageBusinesses,
    setUserData,
    seleccionarNegocio,
    logout
  }
}, {
  persist: {
    key: 'user-store',
    storage: localStorage,
    // Only persist the data we need
    paths: ['usuario', 'negocios', 'negocioSeleccionado']
  }
}) 